import { Component, OnInit } from '@angular/core';
import { ObjectGroupService } from '@app/services/object-group-lines.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-object-group-form',
  templateUrl: './object-group-form.component.html',
  styleUrl: './object-group-form.component.scss'
})

export class ObjectGroupFormComponent implements OnInit{

  OGshortcode = '';
  OGName = '';
  OGRemarks = '';
  objectGroups: any[] = [];
  selectedObjectGroup: string = '';
  useExistingLines = false;
  ObjectGroupLinesArr: any[] = [];
  isEditMode = false;
 finalObjectGroupLinesArr: any[] = [];
    
  constructor(private ObjectGroupService: ObjectGroupService, private router: Router, ) { }

  ngOnInit() {
    this.ObjectGroupService.getobjectGroupList().subscribe(data => this.objectGroups = data);

    const navigation = history.state;
    if (navigation && navigation.editObjectGroup) {
      const editObjectGroup = navigation.editObjectGroup;
      this.isEditMode = true;
      this.OGshortcode = editObjectGroup.objGroupShortcode;
      this.OGName = editObjectGroup.objGroupName;
      this.OGRemarks = editObjectGroup.objGroupRemarks;
      
      this. ObjectGroupLinesArr = [];
      this.useExistingLines = true; // show template selection for clarity if needed
    }
  }

  saveObjectGroup() {
    if (this.useExistingLines && !this.isEditMode && this.selectedObjectGroup) {
      this.ObjectGroupService.getobjectGroupLinesByShortCode(this.selectedObjectGroup).subscribe({
        next: (data) => {
          this.finalObjectGroupLinesArr = this.cloneLinesForNewGroup(data);
          this.persistObjectGroup();
        },
        error: () => {
          this.finalObjectGroupLinesArr = [];
          this.persistObjectGroup();
        },
      });
      return;
    }

    if (this.useExistingLines && this.isEditMode) {
      this.finalObjectGroupLinesArr = Array.isArray(this.ObjectGroupLinesArr) ? this.ObjectGroupLinesArr : [];
    } else {
      this.finalObjectGroupLinesArr = [];
    }
    this.persistObjectGroup();
  }

  /** Copy source lines for insert under the new group shortcode (backend renumbers lineSrno). */
  private cloneLinesForNewGroup(lines: unknown): any[] {
    if (!Array.isArray(lines)) return [];
    return lines.map((line) => ({
      ...line,
      objGroupShortcode: this.OGshortcode,
    }));
  }

  private persistObjectGroup(): void {
    const newObjectGroup = {
      objGroupShortcode: this.OGshortcode,
      objGroupName: this.OGName,
      objGroupRemarks: this.OGRemarks,
      details: Array.isArray(this.finalObjectGroupLinesArr) ? this.finalObjectGroupLinesArr : [],
    };
    this.ObjectGroupService.saveobjectGroup(newObjectGroup).subscribe(() => {
      this.router.navigate(['/designer/object-group-list']);
    });
  }
}
